<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled" style="padding: 0px">
      <a-form-model ref="form" :model="model" slot="detail" style="padding: 0px">
        <a-row>
          <a-col :span="12">
            <a-form-model-item :label="language['eletronicSigned.processNo']" :labelCol="labelCol" :wrapperCol="wrapperCol"><!-- prop="applicationCode"-->
              <a-input v-model="model.processNo" placeholder="" :disabled="isDisabled"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="language['eletronicSigned.startTime']" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-date-picker
                style="width: 100%"
                :disabled="isDisabled"
                v-model="model.startTime"
                :format="'YYYY-MM-DD HH:mm:ss'"
                :getCalendarContainer="node => node.parentNode"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-tabs @change="changeTabs" default-active-key="1" size="large" :tab-bar-style="{marginBottom: '24px', paddingLeft: '16px'}" style="max-height: 63vh;">
          <a-tab-pane loading="true" :tab="model.processName" key="1" style="max-height: 60vh;overflow:scroll">
            <details-modal  :form-id="model.formId" :form-no="model.businessFormNo"/>
          </a-tab-pane>
          <!--<a-tab-pane :tab="language['eletronicSigned.fileUrls']" key="2" v-if="processModel.applicationCode === 'ipsys'&&(model.task_code==='ApproveTask8'||model.task_code==='ApproveTask9')"style="max-height: 60vh;overflow:scroll">&lt;!&ndash;v-if="testfile.length>0"&ndash;&gt;
            <a-col :span="24">
              <a-form-model-item :label="language['eletronicSigned.fileUrls']" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <j-upload upload-source="ipsys" disabled
                          @change="handleChange"
                          :customName="true"
                          :multiple="fileAttribute.fileMultiple"
                          v-model="fileUrls"
                ></j-upload>
              </a-form-model-item>
            </a-col>
          </a-tab-pane>-->

          <a-tab-pane :tab="language['eletronicSigned.signList']" key="2" style="max-height: 60vh;overflow:scroll">
            <!--<div>签核记录:</div>-->
            <a-card :loading="loading" :bordered="false" :title="language['eletronicSigned.signList']" ><!--:style="{ marginTop: '12px' }"-->
              <a-table
                size="middle"
                :columns="columns"
                :pagination="false"
                :dataSource="dataSource"
                :loading="loading">
              </a-table>
            </a-card>
            <!--签核人信息:-->
            <a-card :loading="loading" :bordered="false" :title="language['eletronicSigned.signPerson']" ><!--:style="{ marginTop: '12px' }"-->
              <a-table :columns="approverColumns" size="middle"
                       :data-source="approverData" :pagination="false" :loading="loading"></a-table>
            </a-card>
          </a-tab-pane>
          <a-tab-pane :tab="language['eletronicSigned.processChart']" key="3" style="max-height: 80vh;overflow:scroll">
            <!--<img style="width: 100%;max-height: 60vh;" :src="getProcessChart()">-->
            <div style="padding: 10px;overflow-x: scroll;">
              <a-steps  size="small">
                <a-step :title="language['bpm.sign.startTaskName']" status="finish">
                  <template slot="description">
                    <p style="color:green" slot="title">{{model.createUserRealname}}</p>
                  </template>
                </a-step>
                <a-step  :title="item.taskName" v-for="(item,index) in chartList" :key="index"
                         :status="item.taskStatus=='Ready'?'process':(item.taskStatus=='Rejected'?'error':(item.taskStatus=='Completed'?'finish':'wait'))" >
                  <template slot="description">
                    <p slot="title" v-for="(signUser,i) in item.signUsers" :key="i"
                       :style="(model.processStatus=='Cancelled')?(signUser.isSign==1?'color:green':''):(signUser.isSign==1?'color:green':(signUser.ready?'color:red':''))" >
                      {{signUser.userCodeName}}
                    </p>
                  </template>
                </a-step>
                <a-step :title="language['bpm.sign.endTaskName']" description="" :status="model.processStatus == 'Completed'?'finish':'wait'"/>
              </a-steps>
            </div>
          </a-tab-pane>
        </a-tabs>

      </a-form-model>

    </j-form-container>
  </a-spin>
</template>

<script>
  import {httpAction, getAction, postAction} from '@/api/manage'
  import JInput from '@/components/jeecg/JInput'
  import DetailsModal from './DetailsModal'

  export default {
    name: 'MyFinishedForm',
    components: {
      JInput,
      DetailsModal
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data() {
      return {
        fileUrls:[],
        ipsys_aid:'',
        formCode:'',



        pageType:'myApply',
        tabName:"",
        epDanger: {},
        isDisabled:true,
        processChartPrefix: "",
        processChartSuffix: "",
        processGuid: "",
        loading:true,
        model: {
        },
        labelCol: {
          xs: {span: 24},
          sm: {span: 6},
        },
        wrapperCol: {
          xs: {span: 24},
          sm: {span: 16},
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
        confirmLoading: false,

        approverData:[
          /*{
            key: '10',
            approverOrgLevelNo: 'John Brown',
            approverName: 32,
            approverEmail: 'New York No. 1 Lake Park',
          },*/
        ],

        dataSource:[
          /*{
            key: '1',
            taskTextLocalLang: '隐患单（A）',
            approverName: 'W0105000',
            approveResult: '同意',
            approveComments: '你说的都对',
            approveDate: '2021-10-11',
          },
          */
        ],
        chartList:[],
        url: {
          loadApproveResult: "/sys/wfapi/loadApproveResultGet",//获取签核记录
          getAllTaskApproversInfo: "/sys/wfapi/getAllTaskApproversInfo",//获取所有签核人
          loadEpDangerInfo: "/epm/publicApi/loadEpDangerInfoByFormNo",
        },
        processModel:{},
        fileAttribute:{
          fileMultiple:true,
          fileDisabled:false,
          number:1,
        },
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      columns() {
        if (this.language) {
          return [
            {
              title: this.language['eletronicSigned.taskText'],
              align: "center",
              dataIndex: 'taskName',
              width: 120,
            },
            {
              title: this.language['eletronicSigned.signPerson'],
              align: "center",
              width: 100,
              dataIndex: 'signUserName',
            },
            {
              title: this.language['eletronicSigned.signResult'],
              align: "center",
              width: 80,
              dataIndex: 'signResult_dictText',
              // scopedSlots: {customRender: 'approveResult'},
              /*customRender: function (text, r, index) {
                if (text === 'Cancel') {
                  // return this.language['eletronicSigned.termination']
                  return this.getLanguage('eletronicSigned.termination')
                } else {
                  return r.actionTextLocalLang;
                }
              }*/
            },
            {
              title: this.language['eletronicSigned.signOpinion'],
              align: "center",
              width: 80,
              dataIndex: 'signComments',
            },
            {
              title: this.language['eletronicSigned.signDate'],
              align: "center",
              width: 100,
              dataIndex: 'createTime'
            },
          ]
        }
      },
      approverColumns() {
        if (this.language) {
          return [
            {
              title: this.language['eletronicSigned.taskText'],
              align: "center",
              dataIndex: 'taskName'
            },
            {
              title: this.language['eletronicSigned.signPersonWorkNo'],
              align: "center",
              dataIndex: 'userCode'
            },
            {
              title: this.language['eletronicSigned.signPerson'],
              align: "center",
              dataIndex: 'userCodeName'
            },
            {
              title: this.language['eletronicSigned.signPersonMail'],
              align: "center",
              dataIndex: 'userEmail'
            },
          ]
        }
      },
      formDisabled() {
        return this.disabled
      },
    },

    created() {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
      console.log("current processGuid --> " + this.model.processGuid);
      /*getAction("/sys/wfapi/getProcessChart",{}).then(res=>{
        if (res.success) {
          this.processChartPrefix=res.result.prefix;
          this.processChartSuffix = res.result.suffix;
        }
      })*/
    },

    methods: {
      getLanguage(value){
        return this.language[value];
      },

      changeTabs(){

      },
      getAllTaskApproversInfo(processNo){
        this.loading = true;
        getAction("/sys/bpm/processTaskUser/getVOListByProcessNo",{processNo:processNo}).then(res=>{
          if (res.success) {
            this.approverData = res.result;
          }
        }).finally(()=>{
          this.loading = false;
        });
      },

      loadApproveResult(processNo){
        this.loading = true;
        getAction("/sys/bpm/processTaskUserResult/getlistByProcessNo",{processNo:processNo}).then(res=>{
          if (res.success) {
            this.dataSource = res.result;
          }
        }).finally(()=>{
          this.loading = false;
        });
      },

      getProcessChart() {
        // return this.processChartPrefix + this.process_guid + this.processChartSuffix + "?timestamp="+ new Date().getTime();
      },

      add() {
        this.edit(this.modelDefault);
      },

      edit(record) {
        this.model = Object.assign({}, record);
        this.visible = true;
        this.loadApproveResult(this.model.processNo);
        this.getAllTaskApproversInfo(this.model.processNo);
        this.initChartList(this.model.id)
        // this.loadFile(this.model.processGuid);
        // this.loadEpDangerInfo(this.model.business_form_no, this.model.model_code);
      },
      initChartList(processId){
        getAction("/sys/bpm/processTask/getVOlistByProcessId",{processId:processId}).then(res=>{
          if(res.success){
            this.chartList = res.result;
          }
        })
      },
      //加载附件
      /*loadFile(processGuid){
        getAction("/sys/processSigned/pfBpmFile/queryByProcessGuid?processGuid="+processGuid).then(res=>{
          if(res.success){
            this.fileUrls = [];
            let data = res.result;
            data.pfBpmFileDetailList.forEach(item=>{
              this.fileUrls.push(item.filePath);
            })
            this.model.file = data;
          }
        })
      },*/
      //查询对应的流程model
      getMode(record){
        if(record.modelGuid){
          getAction("/sys/processSigned/pfBpmModel/queryBymodelGuId?modelGuId="+record.modelGuid,{}).then(res=>{
            if (res.success) {
              this.processModel = res.result;
              if(res.result.applicationCode === 'env_audit'){
                /*this.$nextTick(() => {
                  this.$refs.realForm.edit(record);
                })*/
                this.ipsys_aid = record.bussinessFormNo;
              }else if(res.result.applicationCode === 'ipsys'){
                this.ipsys_aid = record.bussinessFormNo;
              }
            }
          })

        }
      },
      //根据业务单号查询
      /*loadEpDangerInfo(business_form_no, model_code){
        let param = {
          formNo: business_form_no,
          modelCode: model_code
        }
        getAction(this.url.loadEpDangerInfo,param).then(res=>{
          if (res.success) {
            this.epDanger = res.result;
          }
        })
      },*/

      beforeUpload: function (file) {
        var fileType = file.type;
        if (fileType.indexOf('image') < 0) {
          this.$message.warning(this.language['warning.pleaseUploadImage']);
          return false;
        }
        //TODO 验证文件大小
      },
    }
  }
</script>